/** Shared print CSS from OTKEvaluation – parameterized root class. */
export function getEvaluationPrintPageStyle(rootClass = 'crm-evaluation-root') {
  return `
    /* Neodporúčame size/orientation – používateľ môže meniť v print dialógu */
    @page {
      margin: 12mm;
      /* Chrome 131+: číslovanie strán v pätičke */
      @bottom-center {
        content: "Strana " counter(page) " / " counter(pages);
        font-size: 10px;
        font-family: Arial, sans-serif;
      }
    }
    ROOT_CLASS_PLACEHOLDER .print-trend-chart-info { display: none; }
    @media print {
      body { -webkit-print-color-adjust: exact !important; font-family: Arial, sans-serif; }
      table { border-collapse: collapse; width: 100%; }
      .no-print { display: none !important; }
      .print-body {
        position: static !important;
        left: auto !important;
        width: auto !important;
        height: auto !important;
        overflow: visible !important;
        display: block !important;
      }
      ROOT_CLASS_PLACEHOLDER .print-trend-chart-info { display: block !important; }

      /* Jednotná tlač: všetko čiernou, bez podčiarknutia */
      .print-full *, .print-section *, .print-body * {
        color: #000 !important;
        text-decoration: none !important;
      }
      .print-full canvas, .print-section canvas, .print-body canvas,
      .print-full img, .print-section img, .print-body img {
        color: unset !important;
      }

      /* PRINT SECTION: outer table s repeating thead pre každú tabuľku */
      .print-section {
        width: 100% !important;
        border-collapse: collapse !important;
        page-break-after: always !important;
      }
      .print-section:last-child {
        page-break-after: auto !important;
      }
      .print-section thead {
        display: table-header-group !important;
      }
      .print-section-header {
        display: flex !important;
        justify-content: space-between !important;
        align-items: flex-start !important;
        padding: 4mm 0 2mm 0 !important;
      }
      .print-section-header-left {
        flex: 0 0 auto !important;
        text-align: left !important;
      }
      .print-section-title {
        font-size: 18px !important;
        font-weight: 700 !important;
        line-height: 1.3 !important;
        margin: 0 0 4px 0 !important;
        color: #000 !important;
      }
      .print-section-subtitle {
        font-size: 13px !important;
        font-weight: 400 !important;
        line-height: 1.5 !important;
        margin: 0 !important;
        color: #000 !important;
      }
      .print-section-subtitle > div {
        margin-bottom: 2px !important;
      }
      .print-section-subtitle > div:last-child {
        margin-bottom: 0 !important;
      }
      .print-section-logo {
        flex: 0 0 auto !important;
        flex-shrink: 0 !important;
        max-height: 22mm !important;
        max-width: 45mm !important;
        object-fit: contain !important;
        display: block !important;
        visibility: visible !important;
      }
      .print-section-body {
        padding: 0 !important;
      }

      /* Opakovanie stĺpcov (thead) pre DataTable a TreeTable po merge – hlavička vždy viditeľná (aj keby mal thead no-print) */
      .print-section-body .p-datatable thead,
      .print-section-body .p-treetable thead,
      .print-section-body thead.p-treetable-thead,
      .print-section-body thead.p-datatable-thead,
      .print-section-body thead.no-print {
        display: table-header-group !important;
      }
      .print-section-body .p-datatable-scrollable-header {
        display: none !important;
      }
      /* TreeTable scrollable header NESKRÝVAME – hlavička (Oddelenie/Interné/...) zostane viditeľná,
         processFilterRowsForPrint skryje len filter riadky */
      /* Prvý riadok thead (Oddelenie/Interné/Externé/Reklamácie/Spolu) – vždy viditeľný */
      .print-section-body .p-datatable thead tr:first-child,
      .print-section-body .p-treetable thead tr:first-child,
      .print-section-body thead tr:first-child {
        display: table-row !important;
      }
      .print-section-body thead tr:first-child th {
        display: table-cell !important;
      }
      .print-section-body .p-datatable thead tr:not(:first-child),
      .print-section-body .p-treetable thead tr:not(:first-child) {
        display: none !important;
      }
      
      /* Zopakované rodičovské riadky v TreeTable */
      .print-repeated-parent {
        background-color: #f5f5f5 !important;
      }
      .print-repeated-parent td:not(:first-child) {
        color: transparent !important;
      }

      /* Skryť pri tlači: subtitle, prepínače (Áno/Nie, Tabuľka/Graf) – switche sa vôbec netlačia */
      .print-full .p-card-subtitle,
      .print-full .p-card-content > .text-sm.p-card-subtitle,
      .print-full .p-card-header .print-text-value,
      .print-full .p-card-header .p-inputswitch,
      .print-full .p-card-header .no-print,
      .print-full .p-inputswitch,
      .print-full .p-selectbutton {
        display: none !important;
      }

      /* === TYPOGRAFIA: názov tabuľky väčší ako obdobie === */
      .print-title, .print-full .p-card-title, .print-full .p-card-header .p-card-title {
        font-size: 18px !important;
        font-weight: 700 !important;
        line-height: 1.3 !important;
        margin: 0 0 4px 0 !important;
        color: #000 !important;
      }
      .print-subtitle, .print-full .p-card-subtitle, .print-full .p-card-content > .text-sm {
        font-size: 11px !important;
        font-weight: 400 !important;
        line-height: 1.3 !important;
        margin: 0 0 8px 0 !important;
        color: #000 !important;
      }
      .print-full .print-chart-bare-title {
        font-size: 14px !important;
        font-weight: 700 !important;
        margin-bottom: 4px !important;
        color: #000 !important;
      }
      .print-full thead {
        display: table-header-group !important;
      }
      .print-full tfoot {
        display: table-row-group !important;
      }
      .print-full .p-treetable-tbody > tr {
        page-break-inside: avoid !important;
        break-inside: avoid !important;
      }
      .print-full table {
        margin-top: 0px !important;
      }
      /* === FARBY: čierny text, linky a prekliky ako normálny text (žiadna modrá, žiadne podčiarknutie) === */
      .print-full a, .print-full .p-datatable a, .print-full .p-treetable a,
      .print-full [role="button"],
      .print-full a:hover, .print-full a:visited, .print-full a:link { color: #000 !important; text-decoration: none !important; }
      .print-section a, .print-section [role="button"],
      .print-section a:hover, .print-section a:visited, .print-section a:link { color: #000 !important; text-decoration: none !important; }
      .print-body a, .print-body [role="button"],
      .print-body a:hover, .print-body a:visited, .print-body a:link { color: #000 !important; text-decoration: none !important; }
      /* span/div s inline modrou (#2563eb) – pri tlači čierne, bez podčiarknutia */
      .print-full [style*="2563eb"], .print-section [style*="2563eb"], .print-body [style*="2563eb"] { color: #000 !important; text-decoration: none !important; }
      /* Hlavičky a bunky tabuliek – vždy čierna farba (názvy stĺpcov, hodnoty), žiadna modrá */
      .print-full th, .print-full td, .print-full .p-datatable th, .print-full .p-datatable td,
      .print-full .p-treetable th, .print-full .p-treetable td,
      .print-full .p-sortable-column, .print-full .p-datatable .p-sortable-column,
      .print-full .p-treetable .p-sortable-column,
      .print-full .p-datatable thead th, .print-full .p-treetable thead th,
      .print-full .p-datatable tbody td, .print-full .p-treetable tbody td,
      .print-full .p-datatable tfoot td, .print-full .p-treetable tfoot td { color: #000 !important; }
      /* Skryť sort ikony (modré šípky) pri tlači – v každej tlačenej tabuľke */
      .print-full .p-sortable-column-icon,
      .print-full .p-datatable .p-sortable-column .p-sortable-column-icon,
      .print-full .p-treetable .p-sortable-column .p-sortable-column-icon,
      .print-full .p-sortable-column .p-icon,
      .print-full .p-datatable .p-sortable-column .p-icon,
      .print-full .p-treetable .p-sortable-column .p-icon { display: none !important; }

      /* Pätička: @page @bottom-center (Chrome 131+) – staršie prehliadače nemajú číslovanie */

      /* vypnúť scroll a fixnú výšku pri tlači – všetky dáta viditeľné */
      .print-full,
      .print-full .p-treetable-scrollable-body,
      .print-full .p-treetable-scrollable-wrapper,
      .print-full .p-treetable-scrollable-body > div,
      .print-full .p-datatable-scrollable-body,
      .print-full .p-datatable-scrollable-wrapper,
      .print-full .p-datatable-scrollable-body > div,
      .print-full .p-datatable-scrollable,
      .print-full .p-datatable-wrapper,
      .print-full [class*="scrollable"] {
        max-height: none !important;
        height: auto !important;
        min-height: 0 !important;
        overflow: visible !important;
      }
      .print-full .p-datatable-scrollable-body,
      .print-full .p-treetable-scrollable-body {
        overflow-y: visible !important;
        overflow-x: visible !important;
      }

      /* nová tabuľka vždy na novú stranu – jasné oddelenie */
      .print-full.print-section-break {
        page-break-before: always !important;
      }
      /* nadpis + tabuľka/graf vždy spolu – okrem print-table-section */
      .print-full {
        page-break-inside: avoid !important;
        break-inside: avoid !important;
      }
      /* Tab 2 tabuľky: môžu sa zlomiť vnútri, aby nevznikala prázdna druhá strana */
      .print-full.print-table-section {
        page-break-inside: auto !important;
        break-inside: auto !important;
      }
      /* TreeTable/DataTable: umožniť zlom riadkov (rodič + deti nemusia ísť celé na ďalšiu stranu) */
      .print-full .p-treetable .p-treetable-tbody > tr,
      .print-full .p-datatable .p-datatable-tbody > tr {
        page-break-inside: auto !important;
        break-inside: auto !important;
      }
      .print-full .p-card {
        page-break-inside: avoid !important;
        break-inside: avoid !important;
        border: none !important;
        box-shadow: none !important;
        background: transparent !important;
        padding: 0 !important;
        margin: 0 !important;
      }
      .print-full .p-card-body, .print-full .p-card-content {
        border: none !important;
        box-shadow: none !important;
        padding: 0 0 8px 0 !important;
      }
      .print-full .p-card-header {
        padding: 0 0 4px 0 !important;
      }
      /* nadpis + header tabuľky vždy dokopy – nikdy na predošlej strane */
      .print-full .p-card-header,
      .print-full .p-card-title,
      .print-full .p-card-content,
      .print-full thead,
      .print-full .p-datatable-thead {
        page-break-after: avoid !important;
        page-break-before: avoid !important;
      }
      /* titulok grafu nikdy oddelene od grafu */
      .print-full .print-chart-bare-title {
        page-break-after: avoid !important;
        break-after: avoid !important;
      }
      /* sekcia s grafmi – nadpis sekcie + grafy spolu */
      .print-full .print-charts-section {
        page-break-inside: avoid !important;
        break-inside: avoid !important;
      }

      /* Tab2: 2 tabuľky vedľa seba – plná šírka stránky, žiadne scale (žiadne biele okraje vľavo/vpravo) */
      .print-full .print-compare-grid {
        display: grid !important;
        grid-template-columns: 1fr 1fr !important;
        gap: 32px !important;
        margin-bottom: 16px !important;
        padding: 0 !important;
        margin-left: 0 !important;
        margin-right: 0 !important;
        width: 100% !important;
        max-width: 100% !important;
      }
      .print-full .print-compare-grid > *,
      .print-full .print-compare-cell {
        min-width: 0 !important;
        overflow: hidden !important;
        overflow-x: hidden !important;
        isolation: isolate !important;
        padding: 0 !important;
        margin: 0 !important;
      }
      .print-full .print-compare-grid .p-datatable,
      .print-full .print-compare-grid .p-datatable-wrapper,
      .print-full .print-compare-grid .p-datatable-scrollable,
      .print-full .print-compare-grid .p-datatable-scrollable-wrapper {
        width: 100% !important;
        max-width: 100% !important;
        padding: 0 !important;
        margin: 0 !important;
        overflow-x: hidden !important;
      }
      .print-full .print-compare-grid .p-datatable-scrollable-body,
      .print-full .print-compare-grid .p-datatable-scrollable-header,
      .print-full .print-compare-grid .p-datatable-scrollable-footer {
        overflow-x: hidden !important;
      }
      .print-full .print-compare-grid .p-treetable-wrapper,
      .print-full .print-compare-grid .p-treetable-scrollable,
      .print-full .print-compare-grid .p-treetable-scrollable-wrapper {
        padding: 0 !important;
        margin: 0 !important;
        overflow-x: hidden !important;
      }
      .print-full .print-compare-grid .p-treetable-scrollable-body {
        overflow-x: hidden !important;
      }
      /* žiadny horizontálny scrollbar v compare pri tlači */
      .print-full .print-compare-grid .p-datatable-scrollable-wrapper,
      .print-full .print-compare-grid .p-datatable-scrollable-body,
      .print-full .print-compare-grid .p-treetable-scrollable-wrapper,
      .print-full .print-compare-grid .p-treetable-scrollable-body {
        scrollbar-width: none !important;
        -ms-overflow-style: none !important;
      }
      .print-full .print-compare-grid .p-datatable-scrollable-wrapper::-webkit-scrollbar,
      .print-full .print-compare-grid .p-datatable-scrollable-body::-webkit-scrollbar,
      .print-full .print-compare-grid .p-treetable-scrollable-wrapper::-webkit-scrollbar,
      .print-full .print-compare-grid .p-treetable-scrollable-body::-webkit-scrollbar {
        display: none !important;
      }
      .print-full .print-compare-grid .p-datatable-scrollable-body table,
      .print-full .print-compare-grid .p-datatable-scrollable-header table,
      .print-full .print-compare-grid .p-datatable-scrollable-footer table {
        table-layout: fixed !important;
      }

      /* header len na začiatku, footer len na konci – nie na každej strane (table-row-group = neopakuje sa) */
      /* Header filtre (filter row) v tabuľkách sa pri tlači nezobrazujú */
      .print-full .p-datatable thead tr:not(:first-child),
      .print-full .p-treetable thead tr:not(:first-child) {
        display: none !important;
      }
      .print-full thead,
      .print-full .p-datatable-thead,
      .print-full .p-treetable-thead {
        display: table-header-group !important;
      }
      .print-full tfoot,
      .print-full .p-datatable-tfoot {
        display: table-row-group !important;
      }
      .print-full .p-datatable-scrollable-header,
      .print-full .p-datatable-scrollable-footer,
      .print-full .p-treetable-scrollable-footer {
        position: static !important;
      }
      .print-full .p-datatable-scrollable-body table,
      .print-full .p-datatable-scrollable-header table,
      .print-full .p-datatable-scrollable-footer table,
      .print-full .p-treetable-scrollable-footer table {
        width: 100% !important;
      }

      /* === TABUĽKY: konzistentná mierka – single aj compare 10px === */
      .print-full .p-datatable th, .print-full .p-datatable td,
      .print-full .p-treetable th, .print-full .p-treetable td {
        font-size: 10px !important;
        padding: 4px 6px !important;
        line-height: 1.2 !important;
      }
      .print-full .p-datatable table, .print-full .p-treetable table {
        table-layout: auto !important;
      }
      .print-full .p-datatable th:first-child, .print-full .p-datatable td:first-child,
      .print-full .p-treetable th:first-child, .print-full .p-treetable td:first-child {
        max-width: 180px !important;
        word-wrap: break-word !important;
        overflow-wrap: break-word !important;
      }
      /* Compare: rovnaký font 10px */
      .print-full .print-compare-grid .p-datatable colgroup col:nth-child(1) {
        width: 50% !important;
        min-width: 0 !important;
      }
      .print-full .print-compare-grid .p-datatable colgroup col:nth-child(n+2) {
        width: 12% !important;
        min-width: 0 !important;
      }
      .print-full .print-compare-grid .p-datatable th,
      .print-full .print-compare-grid .p-datatable td {
        font-size: 10px !important;
        padding: 3px 4px !important;
      }
      .print-full .print-compare-grid .p-datatable colgroup col {
        min-width: 0 !important;
      }

      /* Tab1 TreeTable v porovnávacom režime – zmenšiť stĺpce, aby sa neprekrývali */
      .print-full .print-compare-grid .p-treetable,
      .print-full .print-compare-grid .p-treetable-wrapper,
      .print-full .print-compare-grid .p-treetable-scrollable,
      .print-full .print-compare-grid .p-treetable-scrollable-wrapper {
        width: 100% !important;
        max-width: 100% !important;
      }
      .print-full .print-compare-grid .p-treetable table {
        width: 100% !important;
        table-layout: fixed !important;
      }
      .print-full .print-compare-grid .p-treetable colgroup col:nth-child(1) {
        width: 50% !important;
        min-width: 0 !important;
      }
      .print-full .print-compare-grid .p-treetable colgroup col:nth-child(n+2) {
        width: 12% !important;
        min-width: 0 !important;
      }
      .print-full .print-compare-grid .p-treetable th,
      .print-full .print-compare-grid .p-treetable td {
        font-size: 10px !important;
        padding: 3px 4px !important;
      }
      .print-full .print-compare-grid .p-treetable colgroup col {
        min-width: 0 !important;
      }

      /* filter riadok: prázdne bunky skryté v JS; bunky s hodnotou zmenšiť */
      .print-full .p-datatable .print-filter-has-value {
        font-size: 8px !important;
        padding: 2px 3px !important;
      }
      .print-full .p-datatable .print-filter-has-value input,
      .print-full .p-datatable .print-filter-has-value .p-dropdown,
      .print-full .p-datatable .print-filter-has-value .p-inputtext {
        font-size: 8px !important;
        min-height: 20px !important;
        height: 20px !important;
        padding: 2px 4px !important;
      }

      /* Grafy: single = pod tabuľkou, compare = 4 grafy na ďalšiu stranu */
      .print-full .print-charts-section {
        page-break-before: auto !important;
      }
      .print-full .print-charts-section.print-charts-compare {
        page-break-before: always !important;
      }
      .print-full .print-chart-row {
        page-break-inside: avoid !important;
        break-inside: avoid !important;
      }


      /* grafy: nadpis + graf vždy spolu – ak nevojdú, graf sa zmenší */
      .print-full .print-chart-bare {
        page-break-inside: avoid !important;
        break-inside: avoid !important;
        padding: 0 !important;
        margin: 0 !important;
        border: none !important;
        max-height: 80mm !important;
        display: flex !important;
        flex-direction: column !important;
      }
      .print-full .print-chart-bare-title {
        margin-bottom: 4px !important;
        padding: 0 !important;
        line-height: 1.2;
        flex-shrink: 0 !important;
      }
      .print-full .print-chart-bare canvas,
      .print-full .print-chart-bare img {
        width: 100% !important;
        max-height: 65mm !important;
        min-height: 0 !important;
        object-fit: contain !important;
      }
      /* fallback pre staré .print-chart-item ak by zostali */
      .print-full .print-chart-item {
        padding: 0 !important;
        margin: 0 !important;
        border: none !important;
      }
      .print-full .print-chart-item .p-card-body,
      .print-full .print-chart-item .p-card-content {
        padding: 0 !important;
      }
      .print-full .print-chart-item .p-card-title {
        font-size: 14px !important;
      }
      .print-full .print-chart-item canvas,
      .print-full .print-chart-item img {
        width: 100% !important;
        height: 100% !important;
      }
      /* 4 grafy (porovnanie): 2×2 grid – max-height, môže sa zmenšiť ak nevojdú nadpis+graf */
      .print-full .print-chart-row {
        display: grid !important;
        grid-template-columns: 1fr 1fr !important;
        grid-template-rows: 1fr 1fr !important;
        max-height: 175mm !important;
        height: auto !important;
        width: 100% !important;
        gap: 4mm !important;
      }
      /* 2 grafy (single): 1×2 grid – max-height pre zachovanie nadpis+graf spolu */
      .print-full .print-chart-row:has(> .grid:only-child) {
        grid-template-rows: 1fr !important;
        max-height: 85mm !important;
        height: auto !important;
      }
      .print-full .print-chart-row > .grid {
        display: contents !important;
      }
      .print-full .print-chart-bare {
        width: 100% !important;
        height: 100% !important;
        min-height: 0 !important;
        display: flex !important;
        flex-direction: column !important;
      }
      .print-full .print-chart-bare-title {
        flex-shrink: 0 !important;
      }
      .print-full .print-chart-bare canvas,
      .print-full .print-chart-bare img {
        flex: 1 !important;
        min-height: 0 !important;
      }
    }
  `.replace(/ROOT_CLASS_PLACEHOLDER/g, rootClass);
}
